/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * DragIcon
 */
export default class DragIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M12 8.1a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zm4 0a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zm-8 0a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zm4 10a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zm4 0a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zm-8 0a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zm4 5a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zm4 0a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zm-8 0a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zm4-20a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zm4 0a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zm-8 0A1.1 1.1 0 108 .9a1.1 1.1 0 000 2.2zm4 10a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zm4 0a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zm-8 0a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zm-4-5a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zm0 10a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zm0 5a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zm0-20A1.1 1.1 0 104 .9a1.1 1.1 0 000 2.2zm0 10a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zm16-5a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zm0 10a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zm0 5a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zm0-20a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zm0 10a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2z"/><g fillRule="evenodd"><use/><use fillRule="nonzero"/></g></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

